import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { useFamilyData } from "../../hooks/useFamilyData";
import { useToast } from "../../components/ui/ToastProvider";

export default function BankCard({ familyId, isPro, canManage }) {
  const { showToast } = useToast();
  const { kids = [] } = useFamilyData(familyId);
  
  const [editingKid, setEditingKid] = useState(null); 
  const [rewardName, setRewardName] = useState("");
  const [rewardGoal, setRewardGoal] = useState(0);
  const [showRewardTracker, setShowRewardTracker] = useState(false);
  const [featureNotice, setFeatureNotice] = useState("");

  const saveGoal = async (kidId) => {
    if (!canManage) return;
    if(!isPro) {
      setFeatureNotice("Goal tracking is a Pro feature.");
      return;
    }
    
    const kidRef = doc(db, "families", familyId, "kids", kidId);
    await updateDoc(kidRef, {
        rewardName: rewardName,
        rewardGoal: Number(rewardGoal),
        showRewardTracker: showRewardTracker
    });
    
    setEditingKid(null);
    showToast({ type: "success", message: "Goal updated." });
  };

  const toggleFreeze = async (kid) => {
    if (!canManage) return;
    if(!isPro) {
      setFeatureNotice("Penalty Box is a Pro feature.");
      return;
    }
    await updateDoc(doc(db, "families", familyId, "kids", kid.id), {
        isFrozen: !kid.isFrozen
    });
    showToast({
      type: "success",
      message: kid.isFrozen ? `${kid.name} is no longer frozen.` : `${kid.name} moved to penalty box.`
    });
  };

  return (
    <div className="glass parent-card">
      <div className="header-flex">
        <h2>Bank & Rewards</h2>
      </div>

      <div className="card-body">
        {!canManage && (
          <p style={{ textAlign: "center", opacity: 0.6 }}>You have view-only access.</p>
        )}
        {featureNotice && (
          <small className="pin-error" role="alert" style={{ marginBottom: 10 }}>
            {featureNotice}
          </small>
        )}
        {kids.map(k => (
          <div key={k.id} className="parent-list-item" style={{ 
              flexDirection: 'column', 
              alignItems: 'stretch',
              background: k.isFrozen ? 'rgba(255, 59, 48, 0.1)' : 'rgba(255,255,255,0.3)' 
            }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <div>
                    <strong>{k.name}</strong>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--success)' }}>
                        💰 {k.points || 0} <span style={{ fontSize: '0.8rem', color: 'var(--text-dark)', opacity: 0.6 }}>pts</span>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <button 
                        className={`btn-nav ${k.isFrozen ? 'danger-btn' : ''}`}
                        disabled={!canManage}
                        onClick={() => toggleFreeze(k)}
                    >
                        {k.isFrozen ? "❄️ Frozen" : "🚫 Penalty"}
                    </button>
                    <button className="btn-nav" disabled={!canManage} onClick={() => {
                        setEditingKid(editingKid === k.id ? null : k.id);
                        setRewardName(k.rewardName || "");
                        setRewardGoal(k.rewardGoal || 0);
                        setShowRewardTracker(k.showRewardTracker || false);
                    }}>🎯 Goal</button>
                </div>
            </div>

            {editingKid === k.id && canManage && (
                <div style={{ marginTop: '10px', padding: '10px', background: 'rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                    <label style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>Reward Name</label>
                    <input 
                        placeholder="e.g. New Lego Set" 
                        value={rewardName} 
                        onChange={e => setRewardName(e.target.value)}
                        style={{ marginBottom: '8px' }}
                    />
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                        <input 
                            type="checkbox" 
                            id={`track-${k.id}`}
                            checked={showRewardTracker} 
                            onChange={e => setShowRewardTracker(e.target.checked)} 
                        />
                        <label htmlFor={`track-${k.id}`} style={{ fontSize: '0.8rem', cursor: 'pointer' }}>
                             Show Progress Bar on Board
                        </label>
                    </div>

                    <label style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>Points Needed</label>
                    <div style={{ display: 'flex', gap: '5px' }}>
                        <input 
                            type="number" 
                            value={rewardGoal} 
                            onChange={e => setRewardGoal(e.target.value)}
                        />
                        <button className="btn-nav success-btn" onClick={() => saveGoal(k.id)}>Save</button>
                    </div>
                </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
